// import React, { useEffect, useState } from "react";
// import TextField from "@mui/material/TextField";
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
// import Navbar from "../../Navbar";
// import "react-toastify/dist/ReactToastify.css";
// import { ToastContainer, toast } from "react-toastify";
// import FormControl from "@mui/material/FormControl";
// import ListItemText from "@mui/material/ListItemText";
// import Select from "@mui/material/Select";
// import Checkbox from "@mui/material/Checkbox";
// // import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { Formik, useFormik } from "formik";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import { withRouter } from "react-router-dom";
// import { actionid, processlist, runninglist, schedulelist, stoppedlist } from "../../../../redux/features/pageSlices";
// import Backdrop from "@mui/material/Backdrop";
// import Loader from "../../../../components/Loader";
// import Box from "@mui/material/Box";
// import Skeleton from "@mui/material/Skeleton";
// import Swal from "sweetalert2";

// // import NumberList from "../blacklist/NumberList";
// import CampaignIcon from "@mui/icons-material/Campaign";
// import { common_axios } from "../../../../App";
// import ScheduledAdmin from "./ScheduledAdmin";
// import RunningAdmin from "./RunningAdmin";
// import StoppedAdmin from "./StoppedAdmin";
// import InProcessAdmin from "./InProcessAdmin";
// import CreateCampaignAdmin from "./CreateCampaignAdmin";
// function MainAdminControl() {
//   const theme = createTheme({
//     components: {
//       MuiInputLabel: {
//         styleOverrides: {
//           asterisk: { color: "red" },
//         },
//       },
//     },
//   });

//   const dispatch = useDispatch();
//   const [open, setOpen] = useState();
//   const [scheduleSkelton, setScheduleSkelton] = useState();

//   const actionId = useSelector((state) => state.pageReducer.actionid?.payload);
//   // console.log("actionid--", actionId);

//   const y = useSelector((state) => state.pageReducer.resumeState?.payload);
//   const x = useSelector((state) => state.pageReducer.unscheduleState?.payload);
//   const a = useSelector((state) => state.pageReducer.pauseState?.payload);
//   const b = useSelector((state) => state.pageReducer.runningState?.payload);
//   const p = useSelector((state) => state.pageReducer.processState?.payload);

//   const c = useSelector((state) => state.pageReducer.stopState?.payload);
//   const reduxRunningList = useSelector(
//     (state) => state.pageReducer.runninglist?.payload
//   );
//   const reduxStoppedList = useSelector(
//     (state) => state.pageReducer.stoppedlist?.payload
//   );

//   const Refresh = useSelector((state) => state.pageReducer.refresh?.payload);
//   const RefreshRunning = useSelector(
//     (state) => state.pageReducer.refreshrunning?.payload
//   );

//   const Mainskelton = useSelector(
//     (state) => state.pageReducer.mainSkelton?.payload
//   );
//   const reduxScheduleList = useSelector(
//     (state) => state.pageReducer.schedulelist?.payload
//   );
//   const reduxProcessList = useSelector(
//     (state) => state.pageReducer.processlist?.payload
//   );
//   const [PageSize1, setPageSize1] = useState(10);
//   const [pageNumber1, setPageNumber1] = useState(0);
//   const [scheduleArray, setSchedulearray] = useState([]);
//   const [runningArray, setRunningArray] = useState([]);
//   const [stoppedArray, setStoppedArray] = useState([]);
//   const [processArray, setProcessArray] = useState([]);

//   const [hideSkeleton, sethideSkeleton] = useState();

//   useEffect(() => {
//     setSchedulearray(reduxScheduleList);
//     setRunningArray(reduxRunningList);
//     setStoppedArray(reduxStoppedList);
//     setProcessArray(reduxProcessList);
//   }, [reduxRunningList, reduxStoppedList, reduxScheduleList, reduxProcessList]);

//   // console.log("scheduleArray--", stoppedArray);

//   async function SchedulePost(values) {
//     // setTableLoader(true);
//     //

//     try {
//       setOpen(true);
//       // setScheduleSkelton(true);
//       // sethideSkeleton(true)
//       const result = await common_axios.post(
//         `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/admin/v1/campaign/schedule/status`,
//         {
//           pageNo: pageNumber1,
//           pageSize: PageSize1,
//         }
//       );
//       // console.log("------resultssss", result);
//       if (result.data.statusDescription.statusCode == 200) {
//         setOpen(false);
//         // sethideSkeleton(false)
       
//         setSchedulearray(result?.data?.scheduled);
//         setRunningArray(result?.data?.running);
//         setStoppedArray(result?.data?.stopped);
        
//          setProcessArray(result?.data?.createdCampaign);
//         // setScheduleSkelton(false);
//         // setData(result.data.scheduledList.content);
//         // await toast.success("success", {
//         //   theme: "colored",
//         //   toastId: customId1,
//         // });
//       } else if (result.data?.statusDescription?.statusCode == 220) {
//         setSchedulearray([]);
//         setRunningArray([]);
//         setStoppedArray([]);

//         setOpen(false);
//         // await toast.error(result.data?.statusDescription?.statusMessage, {
//         //   theme: "colored",
//         // });
//       } else {
//         setOpen(false);
//         // setScheduleSkelton(false);
//         // sethideSkeleton(false)
//         Swal.fire({
//           icon: "error",
//            title: "Oops...", 
//           text:result.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         }); 
//       }
//     } catch (error) {
//       //   console.log(error);
//       setOpen(false);
//       // sethideSkeleton(false)

//       Swal.fire({
//         icon: "error",
//          title: "Oops...",
//         text:"Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//     // console.log("response..", res);
//   }

//   useEffect(() => {
//     SchedulePost();
//   }, [b, y, c, p, Refresh, RefreshRunning]);

//   const schedule = () => {
//     dispatch(actionid("1"));
//   };


//   useEffect(()=>{
//     return()=>{
//       dispatch(actionid("1"))
//     }
//     },[])

//     const callBackFun = (child) => {
//       // console.log("child--", child);
//       setProcessArray(child);
//       // setSchedulearray(child);
//     };

//     useEffect(() => {
//       return () => {
//         dispatch(schedulelist([]));
//         dispatch(runninglist([]));
//         dispatch(stoppedlist([]));
//         dispatch(processlist([]));
//       };
//     }, []);


//   return (
//     <>
//       <main className="main-content position-relative border-radius-lg ">
//         <div>
//           <Backdrop
//             sx={{
//               color: "#fff",
//               zIndex: (theme) => theme.zIndex.drawer + 1,
//             }}
//             open={open}
//           >
//             <Loader />
//           </Backdrop>
//         </div>
//         <div className="container-fluid">
//           <div className="row">
//             <div className="col-xl-12 col-sm-12 mb-xl-0 mb-4">
//               <div className="card mb-3">
//                 <div className="card-header p-3 pt-2">
//                   <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
//                     <i
//                       class="material-icons ttl_icon  opacity-10 rule"
//                       style={{ fontSize: "unset" }}
//                     >
//                       <CampaignIcon className="ttl_icon" />{" "}
//                     </i>
//                   </div>
//                   <div class="pt-1 marginleft_0">
//                     <p class="text-sm mb-0 text-capitalize fw-bold">
//                       Campaign Control
//                     </p>
//                     <p className="text-sm mb-0  text d-inline-block float-end">
//                       Field(s) marked with{" "}
//                       <span className="text-danger fw-bold">*</span> are
//                       mandatory.
//                     </p>
//                   </div>
//                   <div className="text-end pt-1"></div>
//                 </div>
//                 <div className="card-body mt-4">
//                   {Mainskelton == true ? (
//                     <>
//                       <Box sx={{ width: 300 }}>
//                         <Skeleton />
//                         <Skeleton animation="wave" />
//                         <Skeleton animation={false} />
//                       </Box>
//                     </>
//                   ) : (
//                     <>
//                       <ul className="nav nav-tabs" id="myTab" role="tablist">
//                         <li className="nav-item list_1" role="presentation">
//                           <button
//                             // className="nav-link active"

//                             className={
//                               actionId == 1
//                                 ? "nav-link ms-4 active  position-relative"
//                                 : actionId == undefined
//                                 ? "nav-link ms-4 active  position-relative"
//                                 : "nav-link ms-4   position-relative"
//                             }
//                             id="home-tab"
//                             data-bs-toggle="tab"
//                             data-bs-target="#AccountDetails"
//                             type="button"
//                             role="tab"
//                             aria-controls="AccountDetails"
//                             // aria-selected="true"
//                             aria-selected={
//                               actionId == 1
//                                 ? "true"
//                                 : actionId == undefined
//                                 ? "true"
//                                 : "false"
//                             }
//                             // onClick={schedule}
//                             onClick={() => {
//                               schedule();
//                               // SchedulePost();
//                               setPageNumber1(0)

//                               // dispatch("1");
//                             }}
//                           >
//                             Schedule
//                             <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success badge-primary">
//                               {scheduleArray?.totalElements == null
//                                 ? 0
//                                 : scheduleArray?.totalElements}
//                             </span>
//                           </button>
//                         </li>
//                         <li className="nav-item list_1" role="presentation">
//                           <button
//                             // className="nav-link ms-4 position-relative"
//                             className={
//                               actionId == -1
//                                 ? "nav-link ms-4 active position-relative"
//                                 : "nav-link ms-4  position-relative"
//                             }
//                             id="SenderMasking-tab"
//                             data-bs-toggle="tab"
//                             data-bs-target="#SenderMasking"
//                             type="button"
//                             role="tab"
//                             aria-controls="SenderMasking"
//                             // aria-selected="false"
//                             aria-selected={actionId == -1 ? "true" : "false"}
//                             onClick={() => {
//                               // SchedulePost();
//                               dispatch(actionid("-1"));
//                               // dispatch("-1");
//                               setPageNumber1(0)

//                             }}
//                           >
//                             Runnning / In Process
//                             <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill badge bg-success">
//                               {runningArray?.totalElements == null
//                                 ? 0
//                                 : runningArray?.totalElements}
//                             </span>
//                           </button>
//                         </li>
//                         <li className="nav-item list_1" role="presentation">
//                           <button
//                             // className="nav-link ms-2"
//                             className={
//                               actionId == 5
//                                 ? "nav-link ms-4 active position-relative"
//                                 : "nav-link ms-4 position-relative "
//                             }
//                             id="ContactDetails-tab"
//                             data-bs-toggle="tab"
//                             data-bs-target="#ContactDetails"
//                             type="button"
//                             role="tab"
//                             aria-controls="ContactDetails"
//                             // aria-selected="false"
//                             // onClick={fetchContactDetails}
//                             aria-selected={actionId == 5 ? "true" : "false"}
//                             onClick={() => {
//                               // SchedulePost();
//                               dispatch(actionid("5"));
//                               setPageNumber1(0)

//                               // dispatch("5");
//                             }}
//                           >
//                             Stopped
//                             <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
//                               {stoppedArray?.totalElements == null
//                                 ? 0
//                                 : stoppedArray?.totalElements}
//                             </span>
//                           </button>
//                         </li>
//                         <li className="nav-item list_1" role="presentation">
//                           <button
//                             // className="nav-link ms-2"
//                             className={
//                               actionId == 0
//                                 ? "nav-link ms-4 active position-relative"
//                                 : "nav-link ms-4 position-relative "
//                             }
//                             id="ContactDetails-tab11"
//                             data-bs-toggle="tab"
//                             data-bs-target="#ContactDetails11"
//                             type="button"
//                             role="tab"
//                             aria-controls="ContactDetails11"
//                             // aria-selected="false"
//                             // onClick={fetchContactDetails}
//                             aria-selected={actionId == 0 ? "true" : "false"}
//                             onClick={() => {
//                               // SchedulePost();
//                               dispatch(actionid("0"));

//                               // dispatch("5");
//                             }}
//                           >

// Campaign Created                   
//          <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning">
//                               {processArray?.totalElements == null
//                                 ? 0
//                                 : processArray?.totalElements}
//                             </span>
//                           </button>
//                         </li>
//                       </ul>
//                     </>
//                   )}

//                   <div className="tab-content" id="myTabContent">
//                     <div
//                       // className="tab-pane fade show active"
//                       className={
//                         actionId == 1
//                           ? "tab-pane fade show active"
//                           : actionId == undefined
//                           ? "tab-pane fade show active"
//                           : "tab-pane fade show"
//                       }
//                       id="AccountDetails"
//                       role="tabpanel"
//                       aria-labelledby="AccountDetails-tab"
//                     >
//                       <div>
//                         <ScheduledAdmin
//                           scheduleArray={scheduleArray}
//                           open={open}
//                         />
//                       </div>
//                     </div>

//                     <div
//                       // className="tab-pane fade"
//                       className={
//                         actionId == -1
//                           ? "tab-pane fade show active"
//                           : "tab-pane fade show"
//                       }
//                       id="SenderMasking"
//                       role="tabpanel"
//                       aria-labelledby="SenderMasking-tab"
//                     >
//                       <RunningAdmin runningArray={runningArray} open={open} />
//                     </div>
//                     <div
//                       // className="tab-pane fade "
//                       className={
//                         actionId == 5
//                           ? "tab-pane fade show active"
//                           : "tab-pane fade show"
//                       }
//                       id="ContactDetails"
//                       role="tabpanel"
//                       aria-labelledby="AccountDetails-tab"
//                     >
//                       <StoppedAdmin stoppedArray={stoppedArray} open={open} />
//                     </div>

//                     <div
//                       // className="tab-pane fade"
//                       className={
//                         actionId == 0
//                           ? "tab-pane fade show active"
//                           : "tab-pane fade show"
//                       }
//                       id="ContactDetails-tab11"
//                       role="tab"
//                       aria-labelledby="ContactDetails-tab11"
//                     >
//                     <CreateCampaignAdmin processArray={processArray} open={open} 
//                     parentCallback={callBackFun}

//                     /> 
//                       {/* <InProcessAdmin processArray={processArray} open={open} /> */}
//                     </div>
//                   </div>

// {
//   actionId == -1 ?(<>
//     <div className="d-flex mt-3 me-3 mb-3 justify-content-center">
//                     <div className="main_box up_buttonStyle px-4">
//                       <Link
//                         to="/dashboard/48HourReport"
//                         style={{ color: "#63B7E6"}}
//                       >
//                         <span className="fw-bold text-white">Completed Campaign</span>
//                       </Link>
//                     </div>
//                   </div>
//   </>):(<>
//     <div className="d-flex mt-3 me-3 mb-3 justify-content-center">
//                     <div className="main_box up_buttonStyle px-4">
//                       <Link
//                         to="/dashboard/TransactionalReport"
//                         style={{ color: "#63B7E6"}}
//                       >
//                         <span className="fw-bold text-white">Completed Campaign</span>
//                       </Link>
//                     </div>
//                   </div>
//   </>)
// }

               
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </main>
//     </>
//   );
// }

// export default withRouter(MainAdminControl);













import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Navbar from "../../Navbar";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
// import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import axios from "axios";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Formik, useFormik } from "formik";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { withRouter } from "react-router-dom";
import { actionid, processlist, runninglist, schedulelist, stoppedlist } from "../../../../redux/features/pageSlices";
import Backdrop from "@mui/material/Backdrop";
import Loader from "../../../../components/Loader";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Swal from "sweetalert2";

// import NumberList from "../blacklist/NumberList";
import CampaignIcon from "@mui/icons-material/Campaign";
import { common_axios } from "../../../../App";
import ScheduledAdmin from "./ScheduledAdmin";
import RunningAdmin from "./RunningAdmin";
import StoppedAdmin from "./StoppedAdmin";
import InProcessAdmin from "./InProcessAdmin";
import CreateCampaignAdmin from "./CreateCampaignAdmin";
function MainAdminControl() {
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
        },
      },
    },
  });

  const dispatch = useDispatch();
  const [open, setOpen] = useState();
  const [scheduleSkelton, setScheduleSkelton] = useState();

  const actionId = useSelector((state) => state.pageReducer.actionid?.payload);
  // console.log("actionid--", actionId);

  const y = useSelector((state) => state.pageReducer.resumeState?.payload);
  const x = useSelector((state) => state.pageReducer.unscheduleState?.payload);
  const a = useSelector((state) => state.pageReducer.pauseState?.payload);
  const b = useSelector((state) => state.pageReducer.runningState?.payload);
  const p = useSelector((state) => state.pageReducer.processState?.payload);

  const c = useSelector((state) => state.pageReducer.stopState?.payload);
  const reduxRunningList = useSelector(
    (state) => state.pageReducer.runninglist?.payload
  );
  const reduxStoppedList = useSelector(
    (state) => state.pageReducer.stoppedlist?.payload
  );

  const Refresh = useSelector((state) => state.pageReducer.refresh?.payload);
  const RefreshRunning = useSelector(
    (state) => state.pageReducer.refreshrunning?.payload
  );

  const Mainskelton = useSelector(
    (state) => state.pageReducer.mainSkelton?.payload
  );
  const reduxScheduleList = useSelector(
    (state) => state.pageReducer.schedulelist?.payload
  );
  const reduxProcessList = useSelector(
    (state) => state.pageReducer.processlist?.payload
  );
  const [PageSize1, setPageSize1] = useState(10);
  const [pageNumber1, setPageNumber1] = useState(0);
  const [scheduleArray, setSchedulearray] = useState([]);
  const [runningArray, setRunningArray] = useState([]);
  const [stoppedArray, setStoppedArray] = useState([]);
  const [processArray, setProcessArray] = useState([]);
  const [paginationPage, setPaginationPage] = React.useState(1);

  const [hideSkeleton, sethideSkeleton] = useState();

  useEffect(() => {
    setSchedulearray(reduxScheduleList);
    setRunningArray(reduxRunningList);
    setStoppedArray(reduxStoppedList);
    setProcessArray(reduxProcessList);
  }, [reduxRunningList, reduxStoppedList, reduxScheduleList, reduxProcessList]);

  // console.log("scheduleArray--", stoppedArray);

  async function SchedulePost(values) {
    // setTableLoader(true);
    //

    try {
      setOpen(true);
      // setScheduleSkelton(true);
      // sethideSkeleton(true)
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/admin/v1/campaign/schedule/status`,
        {
          pageNo: pageNumber1,
          pageSize: PageSize1,
        }
      );
      // console.log("------resultssss", result);
      if (result.data.statusDescription.statusCode == 200) {
        setOpen(false);
        // sethideSkeleton(false)
       
        setSchedulearray(result?.data?.scheduled);
        setRunningArray(result?.data?.running);
        setStoppedArray(result?.data?.stopped);
        
         setProcessArray(result?.data?.createdCampaign);
        // setScheduleSkelton(false);
        // setData(result.data.scheduledList.content);
        // await toast.success("success", {
        //   theme: "colored",
        //   toastId: customId1,
        // });
      } else if (result.data?.statusDescription?.statusCode == 220) {
        setSchedulearray([]);
        setRunningArray([]);
        setStoppedArray([]);

        setOpen(false);
        // await toast.error(result.data?.statusDescription?.statusMessage, {
        //   theme: "colored",
        // });
      } else {
        setOpen(false);
        // setScheduleSkelton(false);
        // sethideSkeleton(false)
        Swal.fire({
          icon: "error",
           title: "Oops...", 
          text:result.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        }); 
      }
    } catch (error) {
      //   console.log(error);
      setOpen(false);
      // sethideSkeleton(false)

      Swal.fire({
        icon: "error",
         title: "Oops...",
        text:"Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
    // console.log("response..", res);
  }

  useEffect(() => {
    SchedulePost();
  }, [b, y, c, p, Refresh, RefreshRunning]);

  const schedule = () => {
    dispatch(actionid("1"));
  };


  useEffect(()=>{
    return()=>{
      dispatch(actionid("1"))
    }
    },[])

    const callBackFun = (child) => {
      // console.log("child--", child);
      setProcessArray(child);
      // setSchedulearray(child);
    };

    useEffect(() => {
      return () => {
        dispatch(schedulelist([]));
        dispatch(runninglist([]));
        dispatch(stoppedlist([]));
        dispatch(processlist([]));
      };
    }, []);


  return (
    <>
      <main className="main-content position-relative border-radius-lg ">
        <div>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={open}
          >
            <Loader />
          </Backdrop>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12 col-sm-12 mb-xl-0 mb-4">
              <div className="card mb-3">
                <div className="card-header p-3 pt-2">
                  <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
                    <i
                      class="material-icons ttl_icon  opacity-10 rule"
                      style={{ fontSize: "unset" }}
                    >
                      <CampaignIcon className="ttl_icon" />{" "}
                    </i>
                  </div>
                  <div class="pt-1 marginleft_0">
                    <p class="text-sm mb-0 text-capitalize fw-bold">
                      Campaign Control
                    </p>
                    <p className="text-sm mb-0  text d-inline-block float-end">
                      Field(s) marked with{" "}
                      <span className="text-danger fw-bold">*</span> are
                      mandatory.
                    </p>
                  </div>
                  <div className="text-end pt-1"></div>
                </div>
                <div className="card-body mt-4">
                  {Mainskelton == true ? (
                    <>
                      <Box sx={{ width: 300 }}>
                        <Skeleton />
                        <Skeleton animation="wave" />
                        <Skeleton animation={false} />
                      </Box>
                    </>
                  ) : (
                    <>
                      <ul className="nav nav-tabs" id="myTab" role="tablist">
                        <li className="nav-item list_1" role="presentation">
                          <button
                            // className="nav-link active"

                            className={
                              actionId == 1
                                ? "nav-link ms-4 active  position-relative"
                                : actionId == undefined
                                ? "nav-link ms-4 active  position-relative"
                                : "nav-link ms-4   position-relative"
                            }
                            id="home-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#AccountDetails"
                            type="button"
                            role="tab"
                            aria-controls="AccountDetails"
                            // aria-selected="true"
                            aria-selected={
                              actionId == 1
                                ? "true"
                                : actionId == undefined
                                ? "true"
                                : "false"
                            }
                            // onClick={schedule}
                            onClick={() => {
                              schedule();
                              SchedulePost();
                              // setPageNumber1(0)
                              setPaginationPage(1)

                              // dispatch("1");
                            }}
                          >
                            Schedule
                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success badge-primary">
                              {scheduleArray?.totalElements == null
                                ? 0
                                : scheduleArray?.totalElements}
                            </span>
                          </button>
                        </li>
                        <li className="nav-item list_1" role="presentation">
                          <button
                            // className="nav-link ms-4 position-relative"
                            className={
                              actionId == -1
                                ? "nav-link ms-4 active position-relative"
                                : "nav-link ms-4  position-relative"
                            }
                            id="SenderMasking-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#SenderMasking"
                            type="button"
                            role="tab"
                            aria-controls="SenderMasking"
                            // aria-selected="false"
                            aria-selected={actionId == -1 ? "true" : "false"}
                            onClick={() => {
                              SchedulePost();
                              dispatch(actionid("-1"));
                              // dispatch("-1");
                              // setPageNumber1(0)
                              setPaginationPage(1)

                            }}
                          >
                            Runnning / In Process
                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill badge bg-success">
                              {runningArray?.totalElements == null
                                ? 0
                                : runningArray?.totalElements}
                            </span>
                          </button>
                        </li>
                        <li className="nav-item list_1" role="presentation">
                          <button
                            // className="nav-link ms-2"
                            className={
                              actionId == 5
                                ? "nav-link ms-4 active position-relative"
                                : "nav-link ms-4 position-relative "
                            }
                            id="ContactDetails-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#ContactDetails"
                            type="button"
                            role="tab"
                            aria-controls="ContactDetails"
                            // aria-selected="false"
                            // onClick={fetchContactDetails}
                            aria-selected={actionId == 5 ? "true" : "false"}
                            onClick={() => {
                              SchedulePost();
                              dispatch(actionid("5"));
                              // setPageNumber1(0)
                              setPaginationPage(1)

                              // dispatch("5");
                            }}
                          >
                            Stopped
                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                              {stoppedArray?.totalElements == null
                                ? 0
                                : stoppedArray?.totalElements}
                            </span>
                          </button>
                        </li>
                        <li className="nav-item list_1" role="presentation">
                          <button
                            // className="nav-link ms-2"
                            className={
                              actionId == 0
                                ? "nav-link ms-4 active position-relative"
                                : "nav-link ms-4 position-relative "
                            }
                            id="ContactDetails-tab11"
                            data-bs-toggle="tab"
                            data-bs-target="#ContactDetails11"
                            type="button"
                            role="tab"
                            aria-controls="ContactDetails11"
                            // aria-selected="false"
                            // onClick={fetchContactDetails}
                            aria-selected={actionId == 0 ? "true" : "false"}
                            onClick={() => {
                              SchedulePost();
                              dispatch(actionid("0"));
                              setPaginationPage(1)

                              // dispatch("5");
                            }}
                          >

Campaign Created                   
         <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning">
                              {processArray?.totalElements == null
                                ? 0
                                : processArray?.totalElements}
                            </span>
                          </button>
                        </li>
                      </ul>
                    </>
                  )}

                  <div className="tab-content" id="myTabContent">
                    <div
                      // className="tab-pane fade show active"
                      className={
                        actionId == 1
                          ? "tab-pane fade show active"
                          : actionId == undefined
                          ? "tab-pane fade show active"
                          : "tab-pane fade show"
                      }
                      id="AccountDetails"
                      role="tabpanel"
                      aria-labelledby="AccountDetails-tab"
                    >
                      <div>
                        <ScheduledAdmin
                          scheduleArray={scheduleArray}
                          open={open}
                        />
                      </div>
                    </div>

                    <div
                      // className="tab-pane fade"
                      className={
                        actionId == -1
                          ? "tab-pane fade show active"
                          : "tab-pane fade show"
                      }
                      id="SenderMasking"
                      role="tabpanel"
                      aria-labelledby="SenderMasking-tab"
                    >
                      <RunningAdmin runningArray={runningArray} open={open} />
                    </div>
                    <div
                      // className="tab-pane fade "
                      className={
                        actionId == 5
                          ? "tab-pane fade show active"
                          : "tab-pane fade show"
                      }
                      id="ContactDetails"
                      role="tabpanel"
                      aria-labelledby="AccountDetails-tab"
                    >
                      <StoppedAdmin stoppedArray={stoppedArray} open={open} />
                    </div>

                    <div
                      // className="tab-pane fade"
                      className={
                        actionId == 0
                          ? "tab-pane fade show active"
                          : "tab-pane fade show"
                      }
                      id="ContactDetails-tab11"
                      role="tab"
                      aria-labelledby="ContactDetails-tab11"
                    >
                    <CreateCampaignAdmin processArray={processArray} open={open} 
                    parentCallback={callBackFun}

                    /> 
                      {/* <InProcessAdmin processArray={processArray} open={open} /> */}
                    </div>
                  </div>

{
  actionId == -1 ?(<>
    <div className="d-flex mt-3 me-3 mb-3 justify-content-center">
                    <div className="main_box up_buttonStyle px-4">
                      <Link
                        to="/dashboard/48HourReport"
                        style={{ color: "#63B7E6"}}
                      >
                        <span className="fw-bold text-white">Completed Campaign</span>
                      </Link>
                    </div>
                  </div>
  </>):(<>
    <div className="d-flex mt-3 me-3 mb-3 justify-content-center">
                    <div className="main_box up_buttonStyle px-4">
                      <Link
                        to="/dashboard/TransactionalReport"
                        style={{ color: "#63B7E6"}}
                      >
                        <span className="fw-bold text-white">Completed Campaign</span>
                      </Link>
                    </div>
                  </div>
  </>)
}

               
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default withRouter(MainAdminControl);
